import React from 'react';
import PropTypes from 'prop-types';
import {Button, Colours} from '@learningblocks/shared-components';
import {Icons} from '@learningblocks/exp-constants';
import {ALPHABET_LIST} from '../StepItem/StepItem.constants';

const {HexagonOutline: HexagonIcon} = Icons;

export function StatusBlock(props) {
  const renderButton = (func, label) =>
    func ? (
      <Button type='secondary' onClick={func}>
        {label}
      </Button>
    ) : null;

  return (
    <div className={props.className}>
      <div className={`${props.className}_previousBlock`}>
        {renderButton(props.onClickPrevious, 'Previous')}
      </div>
      <div className={`${props.className}_status`}>
        <HexagonIcon style={{fill: Colours.colorPrimary}} className='icon' />
        <p>
          {props.activeTask}.{ALPHABET_LIST[props.activeStep]}
        </p>
      </div>
      <div className={`${props.className}_nextBlock`}>
        {renderButton(props.onClickNext, 'Next')}
      </div>
    </div>
  );
}

StatusBlock.propTyeps = {
  /**
   * className for component
   */
  className: PropTypes.string,
  /**
   * Active task number
   */
  activeTask: PropTypes.number,
  /**
   * Active step number
   */
  activeStep: PropTypes.number,
  /**
   * onClick for next-button [ If this is undefined button wont be displayed]
   */
  onClickNext: PropTypes.func,
  /**
   * onClick for previous-button [ If this is undefined button wont be displayed]
   */
  onClickPrevious: PropTypes.func,
};

StatusBlock.defaultProps = {};
